'use client';

import NumberField from '@koda/koda-components/molecules/NumberField';
import { getLatestQuarterLabel, getLatestQuarterYear } from '@koda/koda-utils/date';
import { useLocale, useTranslations } from 'next-intl';
import { ReactElement } from 'react';
import { LicenseTypes } from '../../../types/licenses';
import { useLicenseBusiness } from '../hooks/useLicenseBusiness';
import { CINEMA_CONTENT_PATH, cinemaSchema, createCinemaDefaults } from './cinema.Schema';

export default function CinemaComponent(): ReactElement {
  const licenseCode = LicenseTypes.Cinema;

  const { values, setField, getError, costCalculated, showErrors } = useLicenseBusiness(licenseCode, {
    schema: cinemaSchema,
    defaults: createCinemaDefaults,
  });

  const t = useTranslations(CINEMA_CONTENT_PATH);
  const locale = useLocale();

  return (
    <>
      <NumberField
        label={t('revenue.label', {
          quarter: getLatestQuarterLabel(locale),
          year: getLatestQuarterYear(),
        })}
        name="revenue"
        placeholder={t('revenue.placeholder')}
        required
        formatThousands
        disabled={costCalculated}
        value={values.revenue}
        onChange={e => setField('revenue', parseInt(e.target.value))}
        helpText={t('revenue.helpText')}
        error={values.revenue || showErrors ? getError('revenue') : undefined}
        validated={!!values.revenue && !getError('revenue')}
        min={1}
        sign="positive-only"
        styleVariant="border"
      />
    </>
  );
}
